/* tslint:disable */
/* eslint-disable */
/**
 * documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  List200Response,
} from '../models/index';

export interface NewsApiListRequest {
    tenant: string;
    last: string;
}

/**
 * 
 */
export class NewsApi extends runtime.BaseAPI {

    /**
     */
    async listRaw(requestParameters: NewsApiListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<List200Response>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling list().'
            );
        }

        if (requestParameters['last'] == null) {
            throw new runtime.RequiredError(
                'last',
                'Required parameter "last" was null or undefined when calling list().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['last'] != null) {
            queryParameters['last'] = requestParameters['last'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/news/news`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async list(tenant: string, last: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<List200Response> {
        const response = await this.listRaw({ tenant: tenant, last: last }, initOverrides);
        return await response.value();
    }

}
